// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gr-0";
export var animationContainer = "_gr-1";
export var modalContent = "_gr-2";
export var orderName = "_gr-3";
export var refundOption = "_gr-4";
export var refundOptionsContainer = "_gr-5";